module.exports = __webpack_public_path__ + "assets/manual_uAuto-c09f6b12323b31a5720eb8edbb942dcf.pdf";